let BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const homeContent = `${BASE_URL}/getHomePage`;
export const about = `${BASE_URL}/getAboutUs`;
export const faqContent = `${BASE_URL}/getFaqs`;
export const privacyRoute = `${BASE_URL}/getPrivacyPolicy`;
export const citiesRoutes = `${BASE_URL}/getCities`;
export const jobsInfo = `${BASE_URL}/getAllJobs`;
export const careersInfo = `${BASE_URL}/getCareers`;
export const agentsListing = `${BASE_URL}/getAgents`;
export const contactUs = `${BASE_URL}/getContactUs`;
export const newsletter = `${BASE_URL}/newsLetter`;
export const newslettercareer = `${BASE_URL}/newsLetter`;
export const jobsFamily = `${BASE_URL}/getJobsFamily`;
export const educationalLevel = `${BASE_URL}/getExperienceLevel`;
export const contactQuery = `${BASE_URL}/contactQuery`;
export const getJobsBySearch = `${BASE_URL}/getJobsByJobFamily`;
export const applyForJobs = `${BASE_URL}/applyForJobs`;

export const scheduleCharges = `${BASE_URL}/getScheduleCharges`;
export const list = `${BASE_URL}/getOnezappChargesList`;
export const table = `${BASE_URL}/getCharges`;
export const fetchAllSOC = `${BASE_URL}/get-service-charge-files`;
export const SubCharges = `${BASE_URL}/getSubCharges`;
export const accountDeleteRequest = `${BASE_URL}/account-deletion-complaint`;
export const accountDeleteLogin = `${BASE_URL}/account-validation`;
export const otpVerify = `${BASE_URL}/otp-verification`;

// Agent Listing
export const getCities = `${BASE_URL}/agent-cities`;
export const activeAgents = `${BASE_URL}/active-agent`;
